//
import validate from "validate.js"

/**
 * 
 */
export default function (val) {
    return !validate.isEmpty(val) || "Este campo es obligatorio."
}
